<template>
  <div class="d-flex-column justify-start align-start gap-5">
    <div class="d-flex-row justify-start gap-5">
      <label for="" class="t-light regular-l font-family-2">{{
        $t("order_details.platform")
      }}</label>
      <ItemTooltip :text="$t('fc-boost.descriptions.platform')" />
    </div>
    <DropDown
      :placeholder="$t('calculators_common.select_platform')"
      :drop-items="getKeyedPlatforms"
      :select-drop-item="selectPlatform"
      :selected-item="checkoutStore.getSelectedPlatform"
      img="platform"
      v-if="!$isMobile() && !$isTablet()"
    />
    <BottomSheetPicker
      v-else-if="$isMobile() || $isTablet()"
      :title="$t('missed.platform')"
      :show-title="false"
      :items="getKeyedPlatforms"
      item-key="id"
      :selected-item="checkoutStore.getSelectedPlatform"
      :select-filter="selectPlatform"
      :allow-null="false"
    />
  </div>
</template>
<script setup>
import DropDown from "~/components/custom/DropDown.vue";
import ItemTooltip from "./ItemTooltip.vue";
import BottomSheetPicker from "~/components/common/BottomSheetPicker.vue";
const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();
const getKeyedPlatforms = computed(() => {
  return gameStore.getGame?.platforms?.reduce((accumulator, value) => {
    return { ...accumulator, [value.id]: value.title };
  }, {});
});

const selectPlatform = (key, value) => {
  console.log("passedValue", value);
  checkoutStore.setPlatform({
    platform: parseInt(value),
  });
};
</script>
